import { getContext } from '@/context';
import getTotalCredits from '@/utils/monetization/creditsUtils';

import type { CreditsResponse } from '@/types';

/**
 * Current user's credit balance (subscription + addon credits, summed).
 * Goes through the SDK monetization subsystem.
 */
const getUserCredits = async (): Promise<number> => {
  await getContext().monetization.updateCredits();
  const credits =
    (await getContext().monetization.credits.getState()) as CreditsResponse;
  return getTotalCredits(credits);
};

export default getUserCredits;
